// extracted by mini-css-extract-plugin
export var container = "_g4-0";
export var content = "_g4-3";
export var customerTitle = "_g4-4";
export var empty = "_g4-5";
export var gray = "_g4-6";
export var header = "_g4-7";
export var info = "_g4-8";
export var loading = "_g4-2";
export var loadingCard = "_g4-9";
export var oneLine = "_g4-a";
export var personName = "_g4-e";
export var pillContainer = "_g4-b";
export var selected = "_g4-1";
export var text = "_g4-c";
export var twoLines = "_g4-d";
export var unread = "_g4-f";
export var unreadIndicator = "_g4-g";